import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { OfflineModeModel, OfflineModesModel, SettingFactory, SettingModel } from '../models';
import { SettingRepository } from '../repository';
import { BaseService } from './base';

@Injectable({ providedIn: 'root' })
export class SettingsService extends BaseService<SettingModel> {
  private readonly apiService = inject(ApiService);

  constructor(protected override readonly repository: SettingRepository) {
    super(repository);
  }

  public async setSettings(data: SettingModel): Promise<any> {
    try {
      const path: string = `${SettingFactory.getPath()}`;
      return this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async getSettings(): Promise<SettingModel[]> {
    try {
      const path: string = `${SettingFactory.getPath()}`;
      const settings: SettingModel[] = await this.apiService.get<SettingModel[]>({ path });
      return settings;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async setOfflineSettings(offlineData: OfflineModeModel): Promise<any> {
    try {
      const data: OfflineModeModel = {
        uf: offlineData.uf,
        active: offlineData.active,
      };
      const path: string = `${SettingFactory.getPath()}/offline`;
      return this.apiService.post({ path, data });
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async getOfflineSettings(): Promise<OfflineModesModel[]> {
    try {
      const path: string = `${SettingFactory.getPath()}/offline`;
      const offlineSettings: OfflineModesModel[] = await this.apiService.get<OfflineModesModel[]>({ path });
      return offlineSettings;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
